<template>
    <div v-if="pgLoading" class="loadingLogo">
    <img src="/assets/img/logo/charity-logo.png" alt="children's heart logo" />
  </div>
  <div v-else class="">
    <section class="avater-section" :class="locale == 'ar' ? 'rtl' : 'ltr'">
      <div class="container ">
        <div class="row w-100 align-center text-center">
          <div class="col-md-12 text center">
            <div class="box-avater " style="margin-top:30px">
              <br /><br /><br />
              <img
                alt="success"
                class="img-error"
                src="/assets/img/checked.svg"
                style="width:150px"
                loading="lazy"
              />

              <h4 class="sucess-text"><br />تمت عملية الدفع بنجاح</h4>

              <div class="about-btn" v-if="!pgLoading && info.pdf">
                <a
                  :href="info.pdf.original.file"
                  target="_blank"
                  class="optional-btn default-btn theme_btn_bg "
                >
                  <i class="fa fa-file-pdf"></i>
                  معاينة
                  <span></span>
                </a>
              </div>

              <div class="about-btn">
                <br />
                <div class="about-btn">
                  <router-link
                    :to="{ name: 'home' }"
                    class="default-btn theme_btn theme_btn_bg"
                  >
                    <i class="flaticon-right"></i>
                    الرجوع الي الصفحة الرئيسية
                    <span></span>
                  </router-link>
                </div>
                <br /><br />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { trackDonate } from "@/helpers/pixel";
export default {
  name: "successDonationVoucher",
  components: {},
  data() {
    return {
      //
      auth: {
        access_token: "",
      },
      locale: "ar",
      pgLoading: true,
      hash: "",
      info: {},
    };
  },
  mounted() {
  },
  created() {
    //
    if (localStorage.getItem("access_token")) {
      this.auth.access_token = localStorage.getItem("access_token");
    }
    if (localStorage.getItem("locale")) {
      this.locale = localStorage.getItem("locale");
    }

    if (this.$route.query.hash) {
      this.hash = this.$route.query.hash;
    }

    this.fetchData();
  },
  methods: {
    //
    fetchData() {
      this.pgLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
        Authorization: `Bearer ` + this.auth.access_token,
      };
      const options = {
        url: window.baseURL + "/paymentDonationVouchers/success",
        method: "POST",
        data: {},
        params: {
          hash: this.hash,
        },
      };
      this.$axios(options)
        .then((res) => {
          const voucher = res.data || {};
          // trackDonate fires browser pixel + CAPI for Donate event only
          trackDonate(
            {
              value: voucher.price || voucher.amount,
              currency: voucher.currency,
              content_type: "donation_voucher",
            },
            "voucher_" + this.hash,
            null,
            {
              mobile: voucher.mobile,
              email: voucher.email_address,
              name: voucher.name,
            }
          );

          this.pgLoading = false;
          this.info = res.data;
        })
        .catch(() => {})
        .finally(() => {});
    },
  },
};
</script>

<style scoped=""></style>
